import { Reducer } from "redux";
import baseReducer from "../../utilities/BaseReducer";
import IAction from "../../models/IAction";
import InitBackendActions from "../actions/initBackendActions";

export interface IInitState {
    initData: string;
    error: string;
}
const initialState: IInitState = {
    initData: '',
    error: ''
};
export const initBackendReducer: Reducer = baseReducer(initialState, {
    [InitBackendActions.REQUEST_GET_INIT_FINISHED]: (state: IInitState, action: IAction<string>): IInitState => {
        return {
            ...state,
            initData: action.payload || '',
            error: ''
        };
    }
});